import { api } from "./base.api";
import { ChatSession, ChatSessionType } from "./../types";

export const chatAPI = {
  createSession: async (sessionType: ChatSessionType) => {
    const response = await api.post("/chat/sessions", { sessionType });
    return response.data;
  },

  updateSessionIndexes: async (id: string, indexes: number) => {
    const response = await api.post(`/chat/sessions/${id}/indexes`, {
      indexes,
    });
    return response.data;
  },

  getSessions: async () => {
    const response = await api.get("/chat/sessions");
    return response.data;
  },

  getSessionMessages: async (session: { id: string }, page = 1, limit = 20) => {
    const response = await api.get(`/chat/sessions/${session.id}`, {
      params: { page, limit },
    });
    return response.data;
  },

  deleteSession: async (session: { id: string }) => {
    await api.delete(`/chat/sessions/${session.id}`);
  },

  deleteMessage: async (sessionId: string, messageId: string) => {
    await api.delete(`/chat/sessions/${sessionId}/messages/${messageId}`);
  },

  sendMessage: async (
    session: { id: string },
    content: string,
    models: string[]
  ) => {
    const response = await api.post(`/chat/sessions/${session.id}/messages`, {
      content,
      models,
    });
    return response.data;
  },

  updateSessionName: async (id: string, name: string) => {
    await api.post(`/chat/sessions/${id}/name`, { name });
  },

  updateAIMessage: async (
    session: { id: string },
    messageId: string,
    content: string
  ) => {
    await api.post(`/chat/sessions/${session.id}/messages/${messageId}`, {
      content,
    });
  },

  updateSystemMessage: async (
    session: { id: string },
    messageId: string,
    content: string
  ) => {
    await api.post(
      `/chat/sessions/${session.id}/messages/${messageId}/system`,
      {
        content,
      }
    );
  },

  // Folder endpoints
  getFolders: async () => {
    const response = await api.get("/folders");
    return response.data;
  },

  createFolder: async (name: string) => {
    const response = await api.post("/folders", { name });
    return response.data;
  },

  updateFolder: async (id: string, name: string) => {
    const response = await api.put(`/folders/${id}`, { name });
    return response.data;
  },

  deleteFolder: async (id: string) => {
    await api.delete(`/folders/${id}`);
  },

  addChatToFolder: async (folderId: string, id: string) => {
    await api.post(`/folders/${folderId}/chats`, { id });
  },

  removeChatFromFolder: async (id: string) => {
    await api.delete(`/folders/chats/${id}`);
  },
};
